import * as React from 'react'
import { t } from 'ttag'
import { Card } from '../../components/Card/Card'
import NotificationsWrapper from '../../components/Notification/NotificationsWrapper'
import { StartResetPassword$Request } from '../../services/api.types'
import YumBack from '../../components/YumBack/YumBack'
import Typography from '@material-ui/core/Typography'
import InputAdornment from '@material-ui/core/InputAdornment'
import YumTextField from '../../components/YumTextField/YumTextField'
import { ReactComponent as EmailIcon } from '../../assets/v2/icons/email.svg'
import { ReactComponent as EmailFilledIcon } from '../../assets/v2/icons/email-filled.svg'
import YumButton from '../../components/YumButton/YumButton'
import { ReactComponent as ErrorIcon } from '../../assets/v2/icons/error.svg'
import { isEmailFieldErrorVisible } from '../../common/helpers/formHelpers'
import { Tooltip } from '@material-ui/core'
import { ReactComponent as EmailErrorIcon } from '../../assets/v2/icons/email-error.svg'

export interface IForgotPasswordProps {
  startResetPassword(payload: StartResetPassword$Request): void
}

export interface IForgotPasswordState {
  email: string
  isFormValid: boolean
  isFormSubmitted: boolean
  showPassword: boolean
  errors: object
  focus: object
  [key: string]: any
}

export class ForgotPassword extends React.Component<IForgotPasswordProps, IForgotPasswordState> {
  state = {
    email: '',
    isFormValid: true,
    isFormSubmitted: false,
    showPassword: false,
    errors: {
      email: false,
      password: false,
    },
    focus: {
      email: false,
      password: false,
    },
  }

  /*componentDidMount() {
    document.body.classList.add('show-illustration')
  }

  componentWillUnmount(): void {
    document.body.classList.remove('show-illustration')
  }*/

  handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value, name } = event.target
    this.setState({ [name]: value })
  }

  handleFocus = (name: string) => {
    this.setState({ focus: { ...this.state.focus, [name]: true } })
  }

  handleBlur = (name: string) => {
    this.setState({ focus: { ...this.state.focus, [name]: false } })
  }

  handleKeyPress = async (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.keyCode === 13) {
      // @ts-ignore
      event.target.blur()
      await this.onSubmit()
    }
  }

  validateEmailField = async (value: string) => {
    const error = isEmailFieldErrorVisible(value)
    await this.setState({
      errors: { ...this.state.errors, email: error },
    })
    await this.setState({
      isFormValid: this.isFormValid(),
    })
  }

  isFormValid = () => !Object.values(this.state.errors).some(Boolean)

  onSubmit = async (e?: React.FormEvent<HTMLFormElement>) => {
    if (e) {
      e.preventDefault()
    }
    await this.setState({ isFormSubmitted: true })

    await this.validateEmailField(this.state.email)

    if (this.state.isFormValid) {
      await this.props.startResetPassword(this.state)
    }
  }

  render() {
    const emailNotEmpty = !!this.state.email

    const title = t`Recover your
    YuMuuv account`
    return (
      <Card className="login pt-12">
        <div className="login__inner">
          <YumBack to="/login" />
          <NotificationsWrapper />
          <form className="login__form" onSubmit={this.onSubmit} noValidate>
            <Typography className={'h1-desktop'} variant="h1">
              {title}
            </Typography>

            <YumTextField
              placeholder={t`Email`}
              type="email"
              name="email"
              onChange={this.handleInputChange}
              onKeyDown={this.handleKeyPress}
              error={this.state.errors.email}
              onFocus={() => this.handleFocus('email')}
              onBlur={() => this.handleBlur('email')}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    {this.state.errors.email && !this.state.focus.email ? (
                      <EmailErrorIcon />
                    ) : emailNotEmpty || this.state.focus.email ? (
                      <EmailFilledIcon />
                    ) : (
                      <EmailIcon />
                    )}
                  </InputAdornment>
                ),
                endAdornment: this.state.errors.email ? (
                  <InputAdornment position="end">
                    <Tooltip
                      title={t`Something is wrong with this email`}
                      placement="top-end"
                      open={emailNotEmpty && !this.state.focus.email}
                      arrow
                    >
                      <ErrorIcon />
                    </Tooltip>
                  </InputAdornment>
                ) : (
                  ''
                ),
              }}
            />

            <YumButton type="submit">{t`Recover`}</YumButton>
          </form>
        </div>
        <div className="login__sidebar" />
      </Card>
    )
  }
}
